module.exports = __webpack_public_path__ + "img/appdownload.885b378a.png";